import { useLazyQuery, useMutation } from '@apollo/client';
import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import {
  CREATE_PLAN,
  QUERY_CHECK_NAME,
  UPDATE_PLAN,
  QUERY_PROMOTION_PLANS,
  QUERY_PROMOTION_PLAN,
} from '../queries';
import CommissionPlanEditor from './editor';
import { message } from 'antd';
import LoadingModal from '../loading-modal';

const PromotionPlanEditorContainer = ({ modalType, editPlan, handleCloseModal }) => {
  const { t } = useTranslation();
  const queryNamePromiseRef = useRef(null);
  const [createPlan] = useMutation(CREATE_PLAN, { refetchQueries: [QUERY_PROMOTION_PLANS] });
  const [updatePlan] = useMutation(UPDATE_PLAN, { refetchQueries: [QUERY_PROMOTION_PLANS] });
  const [queryEditingPlan, { data: editingPlan }] = useLazyQuery(QUERY_PROMOTION_PLAN, {
    onError: e => {
      message.error(e?.toString());
    },
  });

  const [queryDuplicateName, { data: checkNameData }] = useLazyQuery(QUERY_CHECK_NAME, {
    fetchPolicy: 'no-cache',
  });

  const queryDuplicateNamePromise = name =>
    new Promise((resolve, reject) => {
      queryDuplicateName({ variables: { name, type: 'PROMOTIONAL' } });
      queryNamePromiseRef.current = { resolve, reject };
    });

  useEffect(() => {
    if (checkNameData) {
      queryNamePromiseRef.current.resolve(checkNameData);
    }
  }, [checkNameData]);

  useEffect(() => {
    if (modalType === 'edit') {
      queryEditingPlan({ variables: { id: editPlan.id } });
    }
  }, [modalType]);

  if (modalType === 'edit' && !editingPlan) {
    return (
      <LoadingModal
        activeModal
        handleCloseModal={handleCloseModal}
        title={t(`cms.referral.promotion.modal.${modalType}_promotion.title`)}
      />
    );
  }

  return (
    <CommissionPlanEditor
      activeModal
      t={t}
      type={modalType}
      partners={editPlan?.partners}
      plan={modalType === 'create' ? editPlan : editingPlan.referralCommissionPlan}
      handleCloseModal={handleCloseModal}
      handleSubmit={modalType === 'create' ? createPlan : updatePlan}
      handleCheckDuplicateName={queryDuplicateNamePromise}
    />
  );
};

export default PromotionPlanEditorContainer;
